/** PM Typing Sender — sends typing indicators to the API when the user types. */

import { getApiToken } from '../../modules/tokenUtils.js';

const THROTTLE_MS = 3000;
const TYPING_DELAY = 3000;

let lastSentAt = 0;
let currentThreadId = null;

async function sendTypingIndicator(threadId) {
  const now = Date.now();
  if (now - lastSentAt < THROTTLE_MS) return;
  lastSentAt = now;

  const token = await getApiToken();
  if (!token) return;

  try {
    await fetch('/v1/thread/' + threadId + '/typing', {
      method: 'PUT',
      headers: {
        'X-AUTH-TOKEN': token,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      credentials: 'include',
      body: 'delay=' + TYPING_DELAY
    });
  } catch {
    // Silently ignore — typing indicators are best-effort
  }
}

$(document).on('input', '#message', function () {
  const threadId = window.get_active_thread_id ? window.get_active_thread_id() : null;
  if (!threadId) return;

  // Reset throttle when switching threads
  if (threadId !== currentThreadId) {
    currentThreadId = threadId;
    lastSentAt = 0;
  }

  sendTypingIndicator(threadId);
});
